// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"eb3aa6da","513":"8f7944e1","703":"fb4336ab","787":"bb573d43"}[chunkId] + ".chunk.js";
};